import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a708b0e8295d500148eee9c_1787031392807_2569c526/novaqrstudio/src/app/components/QRGeneratorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a708b0e8295d500148eee9c_1787031392807_2569c526/novaqrstudio/src/components/AppLayout.tsx");
